<template>
  <div class="app">
    <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
      <input
        class="form-control mr-sm-2"
        type="text"
        placeholder="Contiene..."
        style="width:150px"
        v-model="searchTerm"
        @keyup.enter="filterData"
      />

      <input
        class="form-control mr-sm-2"
        type="text"
        placeholder="Empieza con..."
        style="width:150px"
        v-model="startSearchTerm"
        @keyup.enter="filterData"
      />

      <input
        class="form-control mr-sm-2"
        type="text"
        placeholder="Nº Letras"
        style="width:110px"
        v-model="letterCount"
        @keyup.enter="filterData"
      />

      <multiselect
        v-model="selectedCategories"
        :options="allCategories"
        :multiple="true"
        @input="filterData"
      ></multiselect>

      <button class="btn btn-primary ml-2" @click="filterData">Buscar</button>
      <span style="color:white" class="ml-2"
        >{{ filteredData.length }}&nbsp;Palabra{{filteredData.length !== 1 ? "s" : ""}}</span
      >
    </nav>

    <div class="container mt-5 pt-5">
      <a href="/en" :class="{active: lang === 'en'}">Inglés</a> | <a href="/" :class="{active: lang !== 'en'}">Español</a>
      <div v-for="(word, idx) in filteredData" :key="idx" class="mt-3">
        <span>{{ word.id }} </span>
        <h2 class="d-inline-block">
          {{ word.word }}
        </h2>
        <span class="ml-1" v-html="word.extra"></span>
        <span v-for="(categ, idx) in word.categories" :key="idx" :title="categ">
          {{ logos[categ] }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

const words_es = require("../data/es/words.json");
const words_en = require("../data/en/words.json");
const synonyms_es = require("../data/es/synonyms.json");
const antonyms_es = require("../data/es/antonyms.json");
const synonyms_en = require("../data/en/synonyms.json");
const antonyms_en = require("../data/en/antonyms.json");
const normWords_es = removeChars(words_es);
const normWords_en = removeChars(words_en);

const categories_es = require("../data/es/categories.json");
const categories_en = require("../data/en/categories.json");

const logos = {
  "Animales y partes": "🐕‍🦺",
  Vegetales: "🥕",
  Cuerpo: "👅",
  "Alimentos y sabores": "🍲",
  Arte: "🎭",
  "Verbos y relaciones": "🎬",
  "Números, ciencia y juegos": "🔢",
  "Personas y parientes": "🧍",
  "Tiempo y signos": "⏱️",
  "Lugar y objetos": "🌇",
  Sentidos: "👁",
  Sonidos: "🔊",
};

const allCategories = [
  "Animales y partes",
  "Vegetales",
  "Cuerpo",
  "Alimentos y sabores",
  "Arte",
  "Verbos y relaciones",
  "Números, ciencia y juegos",
  "Personas y parientes",
  "Tiempo y signos",
  "Lugar y objetos",
  "Sentidos",
  "Sonidos",
];

function removeChars(wordList) {
  const ret = [];
  for (let i = 0; i < wordList.length; i++) {
    ret.push(wordList[i].normalize("NFKD").replace(/[\u0300-\u036F]/g, ""));
  }
  return ret;
}

function loadWords(lang) {
  const data = [];

  let words = [];
  let normWords = [];
  let synonyms = [];
  let antonyms = [];
  let categories = [];
  if(lang == 'en'){
    words = words_en;
    normWords = normWords_en;
    synonyms = synonyms_en;
    antonyms = antonyms_en;
    categories = categories_en;
  } else {
    words = words_es;
    normWords = normWords_es;
    synonyms = synonyms_es;
    antonyms = antonyms_es;
    categories = categories_es;
  }

  for (let i = 0; i < synonyms.length; i++) {
    const extra = "";
    const search = normWords[i] + " ";

    if (antonyms[i].word != synonyms[i].word) {
      console.log("Loss sync");
    }

    for (let j = 0; j < synonyms[i].synonyms.length; j++) {
      const s = synonyms[i].synonyms[j];
      const idx = normWords.indexOf(s);

      if (idx !== -1) {
        extra += `<strong>${words[idx]}</strong> `;
      } else {
        extra += `<span class="text-not">${s}</span> `;
      }
      search += s + " ";
    }
    for (let j = 0; j < antonyms[i].antonyms.length; j++) {
      const s = antonyms[i].antonyms[j];
      const idx = normWords.indexOf(s);
      if (idx !== -1) {
        extra += `<strong>(${words[idx]})</strong> `;
      } else {
        extra += `<span class="text-not">(${s})</span> `;
      }
      search += s + " ";
    }

    const outCategories = [];

    for (let j = 0; j < categories.categories.length; j++) {
      const category = categories.categories[j];

      if (category.words.includes(normWords[i])) {
        outCategories.push(category.category);
      }
    }

    const anagr = normWords[i]
      .split("")
      .sort()
      .join("");

    data.push({
      id: i + 1,
      word: words[i],
      normWord: normWords[i],
      extra: extra,
      search: search,
      categories: outCategories,
      sortedLetters: anagr,
    });
  }

  return data;
}

export default {
  components: { Multiselect },
  props: [
    "lang"
  ],

  data() {
    return {
      data: loadWords(this.lang),
      searchTerm: "",
      startSearchTerm: "",
      letterCount: "",
      logos: logos,
      allCategories: allCategories,
      selectedCategories: [],
      filteredData: [],
    };
  },
  mounted() {
    this.filterData();
  },
  methods: {
    filterData() {
      this.filteredData = this.data.filter((word) => {
        if (this.letterCount !== "") {
          if (word.word.length != this.letterCount) return false;
        }
        if (this.searchTerm !== "") {
          if (!word.normWord.includes(this.searchTerm)) return false;
        }
        if (this.startSearchTerm !== "") {
          if (!word.search.startsWith(this.startSearchTerm)) return false;
        }

        if (this.selectedCategories.length !== 0) {
          for (let i = 0; i < word.categories.length; i++) {
            if (this.selectedCategories.includes(word.categories[i]))
              return true;
          }

          return false;
        }
        return true;
      });
    },
  },
};
</script>

<style>
.text-not {
  color: rgb(170, 170, 170);
}
a.active{
  font-weight: bold;
}
</style>
